<script lang="ts" setup>
import { useAppStore } from '@/store/app/app'

const appStore = useAppStore()
</script>

<template>
  <the-snackbar :list="appStore.snackbarQueue" />
</template>
